import { Component, Vue } from 'vue-property-decorator';
import {google, Loader, LoaderOptions} from 'google-maps';
import store from '@/store/store';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import OfflineController from '@/assets/ts/controller/OfflineController';
import DynamicRepository from '../offline/repository/DynamicRepository';
import { OfflineTablesName } from '../offline/DynamicTables';
import { LocalizacaoPontoUnidade } from '@/views/RegistroPontoNovo/types-registro-ponto';

declare var cordova: any;

class LocalizacaoController {
  private static readonly API_KEY = 'AIzaSyCuxIZTT-nFhI8pHCR7wBGWvR5v8CVQoPk';
  public static google: google = null;

  public static async init() {
    const options: LoaderOptions = {
      language: 'pt-br',
      region: 'BR',
    };

    const loader = new Loader(self.API_KEY, options);
    self.google = await loader.load();
  }

  private static readonly REJECT_MESSAGE = 'Não foi possível obter o endereço do local';

  public static async getGeoLocation(
    showLoading = true,
  ) {

    if(OfflineController.isMobile()) {
      await this.checkGeoLocationMobile();
    }

    const promise: Promise<{latitude: number, longitude: number}> = new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition((position) => {
        resolve(position.coords);
      }, (positionError) => {
        const message = positionError.message;
        console.log('error:', positionError);
        console.log(message);
        reject(message);
      });
    });

    HttpRequest.saveRequest(promise, null, showLoading);

    return promise;
  }

  public static checkGeoLocationMobile(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const permissions = cordova.plugins.permissions;

      const list = [
        permissions.ACCESS_FINE_LOCATION,
        permissions.ACCESS_COARSE_LOCATION
      ];

      permissions.checkPermission(list, (status) => {
        if (!status.hasPermission) {
          permissions.requestPermissions(list, (status) => {
            if (status.hasPermission) {
              resolve(true);
            } else {
              reject('Permissões de localização não foram concedidas');
            }
          }, (error) => {
            console.warn('Erro ao solicitar permissões de localização:', error);
            reject('Erro ao solicitar permissões de localização');
          });
        } else {
          resolve(true);
        }
      }, (error) => {
        console.warn('Erro ao verificar permissões de localização:', error);
        reject('Erro ao verificar permissões de localização');
      });
    });
  }

  public static getAddressLocation(latitude: number, longitude: number): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {
      const geocoder = new self.google.maps.Geocoder();
      const address = `${latitude}, ${longitude}`;

      geocoder.geocode({address}, (results, status) => {
        if (status.toString() === 'OK') {
          resolve(results[0].formatted_address);
        } else if (status === 'OVER_QUERY_LIMIT') {
          reject(status);
        } else {
          reject(self.REJECT_MESSAGE);
        }
      });
    });

    return promise;
  }

  public static async getPontoAcesso(
    showLoading = true,
  ) {
    const user: User = store.getters.user;
    const nrOrg = user.nrorg;
    const nrVinculo = user.nrvinculom;

    const route = 'getPontoAcesso';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const pontoAcesso: any = response.data.dataset.pontoAcesso;

      return pontoAcesso;
    } catch (err) {
      const errAny: any = err;

      const message = ExpectedError.isExpectedError(errAny) ?
      errAny.message :
        'Não foi possível carregar o ponto de acesso!';

      return message;
    }
  }

  public static async getLocalizacaoRegistroPonto(): Promise<LocalizacaoPontoUnidade> {
    let localizacao = { latitude: 0, longitude: 0 };

      if(OfflineController.isMobile()) {
        try {
          // Cria um timeout de 3 segundos
          let timeoutId: NodeJS.Timeout;
          const timeout = new Promise<never>((_, reject) => {
            timeoutId = setTimeout(() => reject(new Error('Timeout')), 3000);
          });

          // Usa Promise.race para a geolocalização com timeout
          localizacao = await Promise.race([
            LocalizacaoController.getGeoLocation(),
            timeout
          ]);

          // Limpa o timeout se a geolocalização resolver primeiro
          clearTimeout(timeoutId);
        } catch (error) {
          localizacao = await this.getLocalizacaoOffline();
        }
      } else {
        localizacao = await LocalizacaoController.getGeoLocation();
      }

    return localizacao;
  }

  public static async getLocalizacaoOffline() {
    const defaultGeo = { latitude: 0, longitude: 0 };
    try {
      const localizacao = await DynamicRepository.getDynamicTable(OfflineTablesName.USER_LOCATION);
      const resp = localizacao && localizacao.length > 0 ? localizacao[0] : defaultGeo;

      // Tenta converter LATITUDE e LONGITUDE para números
      const latitude = resp && resp.LATITUDE ? parseFloat(resp.LATITUDE) : NaN;
      const longitude = resp && resp.LONGITUDE ? parseFloat(resp.LONGITUDE) : NaN;

      // Verifica se os valores convertidos são números válidos
      if (!isNaN(latitude) && !isNaN(longitude)) {
        return { latitude, longitude };
      }

      // Retorna defaultGeo caso os valores não sejam números
      return defaultGeo
    } catch (error) {
      return defaultGeo;
    }
  }
}

const self = LocalizacaoController;

export default LocalizacaoController;
